import { Select, Tag } from "antd";
import React from "react";
const { Option } = Select;

interface ColoredSelectProps {
  size?: "large" | "middle" | "small";
  height?: string;
  onChange?: (value: any) => void;
  options: Array<NetwalaSelectOptions>;
  value?: string | number | null;
  showSearch?: boolean;
  disabled?: boolean;
  placeHolder?: string;
  colorMap?: Record<string, string>; // Maps option values to colors
}

const ColoredSelect: React.FC<ColoredSelectProps> = ({
  size = "middle",
  height,
  onChange,
  options,
  value,
  showSearch = false,
  disabled = false,
  placeHolder,
  colorMap = {},
}) => {
  const selectStyle: React.CSSProperties = {
    width: "100%",
    ...(height && { height }),
  };

  const getColor = (optionValue: string | number): string | undefined => {
    return colorMap[String(optionValue)];
  };

  return (
    <Select
      disabled={disabled}
      value={value}
      style={selectStyle}
      size={size}
      onChange={onChange}
      showSearch={showSearch}
      optionFilterProp="label"
      placeholder={placeHolder ? placeHolder : ""}
      dropdownRender={(menu) => menu}
    >
      {options.map((option) => {
        const color = getColor(option.value);
        return (
          <Option key={option.value} value={option.value} label={option.label}>
            {color ? (
              <Tag color={color} style={{ margin: 0 }}>
                {option.label}
              </Tag>
            ) : (
              option.label
            )}
          </Option>
        );
      })}
    </Select>
  );
};

export default ColoredSelect;

